import * as yup from "yup";

export const tagSchema = yup.object().shape({
    name: yup.string().required("required"),
});
